import React, { useEffect, useState } from 'react';
import {
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  ModalFooter,
  Box,
} from '@chakra-ui/react';

import { Link } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Changelog as IChangelog } from '../generated/graphqlModels';
import { GET_LAST_CHANGELOG_QUERY, SEE_CHANGELOG } from '../App/queries';
import styled from '../consts/styled';

const Changelog = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [log, setLog] = useState<IChangelog | null>(null);
  const { data } = useQuery<{ getLastChangelog: IChangelog }>(
    GET_LAST_CHANGELOG_QUERY,
  );
  const [seeChangelog] = useMutation<any>(SEE_CHANGELOG);

  useEffect(() => {
    if (data?.getLastChangelog) {
      const newLog = data.getLastChangelog;
      setLog(newLog);
      const startDate = new Date(newLog.startDate);
      const endData = new Date(newLog.endDate);
      const today = new Date();
      startDate.setHours(0, 0, 0, 0);
      endData.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (!newLog.seen && endData >= today && startDate <= today) {
        openChangelog();
        seeChangelog({ variables: { data: { id: newLog.id } } });
      }
    }
  }, [data]);

  const openChangelog = () => {
    onOpen();
  };

  return (
    <>
      {log && log.title ? (
        <Modal size="2xl" onClose={onClose} isOpen={isOpen} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{log.title}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <TinyMceWrapper dangerouslySetInnerHTML={{ __html: log.log }} />
            </ModalBody>
            <ModalFooter>
              <Button onClick={onClose}>{t('general.close')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      ) : null}
      <span style={{ marginLeft: 12 }}></span>
      <Link className="pdf-link" to="#" onClick={openChangelog}>
        {t('changelog')}
      </Link>
    </>
  );
};

export default Changelog;

const TinyMceWrapper = styled(Box)`
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.4;
    margin: 1rem;
  }
  table {
    border-collapse: collapse;
  }
  table:not([cellpadding]) th,
  table:not([cellpadding]) td {
    padding: 0.4rem;
  }
  table[border]:not([border='0']):not([style*='border-width']) th,
  table[border]:not([border='0']):not([style*='border-width']) td {
    border-width: 1px;
  }
  table[border]:not([border='0']):not([style*='border-style']) th,
  table[border]:not([border='0']):not([style*='border-style']) td {
    border-style: solid;
  table[border]:not([border='0']):not([style*='border-color']) th,
  table[border]:not([border='0']):not([style*='border-color']) td {
    border-color: #ccc;
  }
  figure {
    display: table;
    margin: 1rem auto;
  }
  figure figcaption {
    color: #999;
    display: block;
    margin-top: 0.25rem;
    text-align: center;
  }
  hr {
    border-color: #ccc;
    border-style: solid;
    border-width: 1px 0 0 0;
  }
  code {
    background-color: #e8e8e8;
    border-radius: 3px;
    padding: 0.1rem 0.2rem;
  }
  .mce-content-body:not([dir='rtl']) blockquote {
    border-left: 2px solid #ccc;
    margin-left: 1.5rem;
    padding-left: 1rem;
  }
  .mce-content-body[dir='rtl'] blockquote {
    border-right: 2px solid #ccc;
    margin-right: 1.5rem;
    padding-right: 1rem;
  }
`;
